import { useAppSelector, useAppDispatch } from "@app/hooks";
import { useCountDown } from "@helpers/countHelper";
import { NavItems } from "@helpers/navigation";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BasicProps } from "../../../common/components/ComponentsInterface";
import { setSiltentTimeout } from "../../../common/store/assessmentFlowSlice";

export const AssessmentTimeout = ({ micVolume }: AssessmentTimeoutProps): JSX.Element => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const silentTimeout = useAppSelector((x) => x.assessmentFlow.silentTimeout);
    const globalSettings = useAppSelector((x) => x.globalSettings);

    const paths = [
        NavItems.Assessments.AssessmentPresentTargets.path.toLowerCase(),
        NavItems.Assessments.AssessmentFreeRecall.path.toLowerCase(),
        NavItems.Assessments.AssessmentCuedRecalls.path.toLowerCase()
    ];
    const currentPath = location.pathname.toLowerCase();
    const checkTimeout = paths.includes(currentPath);

    const handleOnTimeout = (): void => {
        if (checkTimeout) {
            navigate(NavItems.Login.Landing.path);
        }
    };
    const [counter, resetTimeout] = useCountDown({
        from: silentTimeout,
        onDone: handleOnTimeout
    });

    useEffect(() => {
        if (checkTimeout) {
            if (globalSettings.showLogs) {
                console.log("timeout tick");
                console.log(counter);
            }

            dispatch(setSiltentTimeout(counter));
        }
    }, [counter]);

    useEffect(() => {
        if (checkTimeout && micVolume && micVolume > 0.15) {
            if (globalSettings.showLogs) {
                console.log("sound detected");
                console.log(micVolume);
            }

            resetTimeout(globalSettings.assessmentTimeout);
            dispatch(setSiltentTimeout(globalSettings.assessmentTimeout));
        }
    }, [micVolume]);

    return <></>;
};

interface AssessmentTimeoutProps extends BasicProps {
    micVolume?: number;
}
